import styled from 'styled-components';

export const AccordionContainer = styled.div`
  overflow: hidden;
  margin-bottom: 8px;
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.white};
  cursor: pointer;
  padding: 8px 0px;
  transition: background-color 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #f0f1fa;
  }
`;

export const AccordionTitle = styled.h3`
  margin: 0;
  font-family: ${props => props.theme.fontFamily};
  font-size: 16px;
  font-weight: 400;
  color: #0059b8;
  line-height: 24px;
`;

export const AccordionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0059b8;
`;

export const AccordionContent = styled.div`
  background-color: ${props => props.theme.white};
  overflow: hidden;
  transition: height 0.3s ease-in-out;
  height: ${props => (props.isExpanded ? 'fit-content' : '0')};
`;

export const ContentWrapper = styled.div`
  color: ${props => props.theme.black};
  font-family: ${props => props.theme.fontFamily};
  font-size: 14px;
  line-height: 1.6;
`;
